import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/jvmp/oper_gnb.png'
import _imports_1 from '@/assets/images/jvmp/oper.png'


const _withScopeId = n => (_pushScopeId("data-v-890bce00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "top__wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode(" J-VMP는"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 가상화 기술을 이용하여 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("완벽한 BYOD를"),
  /*#__PURE__*/_createElementVNode("br", { class: "break" }),
  /*#__PURE__*/_createTextVNode(" 실현합니다. ")
], -1))
const _hoisted_4 = { class: "top__wrap__nav" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-right" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "active" }, "모바일 가상화", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top__bg" }, null, -1))
const _hoisted_8 = { class: "lottie" }
const _hoisted_9 = { class: "wrap lottie__wrap" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lottie__wrap__text" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "J-VMP란?"),
  /*#__PURE__*/_createElementVNode("small", null, "(J-Virtual Mobile Platform)"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 지금 사용하던 모바일 단말기 그대로"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("가상의 Android 공간에서 업무 서버의 데이터를"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("암호화된 이미지로 주고 받는 서비스입니다. ")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, " 모바일 가상화 시스템 구조 ")
], -1))
const _hoisted_11 = {
  class: "lottie__wrap__lottie",
  id: "lottie"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrap utube" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "utube__text" }, [
    /*#__PURE__*/_createElementVNode("h3", null, [
      /*#__PURE__*/_createTextVNode(" 뛰어난 안전성과 편리성을 자랑하는"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("span", null, "모바일 가상화 시스템"),
      /*#__PURE__*/_createTextVNode("에 대해"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("자세히 알아보세요. ")
    ]),
    /*#__PURE__*/_createElementVNode("small", null, "동영상으로 편하고 쉽게 알아보는 J-VMP")
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    class: "utube__thumb",
    href: "https://youtu.be/dya2OdwH2EY?si=C9LdxRRtanMwL0eV",
    target: "_blank"
  })
], -1))
const _hoisted_13 = { class: "info__title" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "pbr" }
const _hoisted_16 = { class: "tbr" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "info__title mbr" }
const _hoisted_19 = { class: "wrap oper" }
const _hoisted_20 = { class: "oper__title" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode(" 이미 주요 기관에서 JVMP의"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("성능을 경험하고 있습니다. ")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pbr" }, [
  /*#__PURE__*/_createTextVNode(" 공공, 금융, 국방 분야의 주요 기관에서"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("JVMP로 다양한 모바일 업무 서비스 운영 중 ")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pbr",
  src: _imports_0
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "oper__img",
  src: _imports_1
}, null, -1))
const _hoisted_25 = { class: "oper__title tbr" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 공공, 금융, 국방 분야의 주요 기관에서"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("JVMP로 다양한 모바일 업무 서비스 운영 중 ")
], -1))
const _hoisted_27 = { class: "join" }
const _hoisted_28 = { class: "join__wrap" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-mail" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-phone" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!
  const _component_CustomBtn = _resolveComponent("CustomBtn")!
  const _component_Layout = _resolveComponent("Layout")!

  return (_openBlock(), _createBlock(_component_Layout, { isDark: true }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
            }, " 홈 "),
            _hoisted_5,
            _hoisted_6
          ])
        ]),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            ($setup.lottieShow)
              ? (_openBlock(), _createBlock(_component_Vue3Lottie, {
                  key: 0,
                  loop: false,
                  animationData: $setup.lottie
                }, null, 8, ["animationData"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _hoisted_12,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.info, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "info",
          key: item.i
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("small", null, _toDisplayString(item.label), 1),
            _createElementVNode("h4", {
              innerHTML: item.title
            }, null, 8, _hoisted_14),
            _createElementVNode("p", _hoisted_15, _toDisplayString(item.subtitle), 1),
            _createElementVNode("p", _hoisted_16, _toDisplayString(item.subtitle), 1)
          ]),
          _createElementVNode("img", {
            src: item.img,
            class: "info__img"
          }, null, 8, _hoisted_17),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", null, _toDisplayString(item.subtitle), 1)
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _hoisted_22,
          _createVNode(_component_CustomBtn, {
            class: _normalizeClass('pbr'),
            onOnClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openNewWindow())),
            text: '시연 영상 보기'
          }),
          _hoisted_23
        ]),
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode(_component_CustomBtn, {
            onOnClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openNewWindow())),
            text: '시연 영상 보기'
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("button", {
            class: "join__wrap__btn",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.openEmail && $setup.openEmail(...args)))
          }, [
            _hoisted_29,
            _createTextVNode(_toDisplayString(!$setup.isMobile
							? 'jvmp@thejoin.co.kr'
							: 'E-MAIL'), 1)
          ]),
          _createElementVNode("button", {
            class: "join__wrap__btn",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.openCall && $setup.openCall(...args)))
          }, [
            _hoisted_30,
            _createTextVNode(_toDisplayString(!$setup.isMobile ? '+82-2-6949-0335' : 'CALL'), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}